import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import CheckBoxField from '../components/form/CheckBoxField';
import TermsPopup from '../components/TermsPopup';

import policyText from './privacy-policy';
import termsText from './terms';

const AgreementConfirmationPage = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);
  const [openTerms, setOpenTerms] = React.useState(false);

  return (
    <Box sx={{ px: 2 }}>
      <Typography variant="h4" sx={{ my: 2 }}>
        同意書與投保須知
      </Typography>
      <Box>
        <Box
          component="div"
          dangerouslySetInnerHTML={{
            __html: policyText.replace(/\n/g, '<br/>'),
          }}
          sx={{
            height: '300px',
            overflowY: 'auto',
            border: '1px solid black',
            borderRadius: 2,
            wordWrap: 'break-word',
            p: 2,
            boxShadow: '1px 1px 5px #555 inset',
            boxSize: 'border-box',
            textAlign: 'left',
            mb: 2,
          }}
        />
        <Typography
          variant="body1"
          sx={{
            textAlign: 'left',
            textDecoration: 'underline',
            color: '#9eb3c0',
            cursor: 'pointer',
          }}
          onClick={() => {
            setOpenTerms(true);
          }}
        >
          投保須知條款
        </Typography>
        <TermsPopup
          open={openTerms}
          handleClose={() => setOpenTerms(false)}
          title={'投保須知條款'}
          terms={termsText.replace(/\n/g, '<br/>')}
        />
        <CheckBoxField
          fullWidth
          sx={{ mb: 2 }}
          label="本人已同意"
          value={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Button
            color="secondary"
            variant="contained"
            sx={{ width: 128 }}
            onClick={() => {
              navigate('/dashboard');
            }}
          >
            不同意
          </Button>
          <Button
            variant="contained"
            sx={{ width: 128 }}
            disabled={!checked}
            onClick={() => {
              navigate('/sign-agreement');
            }}
          >
            下一步
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AgreementConfirmationPage;
